"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.validation.providerRequired': 'Il fornitore di pagamenti è richiesto',
    'payment.validation.amountRequired': 'È richiesto un importo valido',
    'payment.validation.currencyRequired': 'La valuta è richiesta',
};
